<template>
    <div 
        v-if="url" 
        class="item-preview-qr-item" 
        :class="{'active': configId == config.id}"
        @click="() => chooseType(config.id)"
    >
        <img :src="url" class="item-preview-qr-item__img" />
    </div>
</template>

<script>
    export default {
        name: "PreviewQrType",
        props: {
            config: {
                type: Object,
                required: true,
            },
            configId: {
                type: String,
                required: true,
            },
            chooseType: {
                type: Function,
                required: true,
            }
        },
        data(){
            return {
                url: ""
            }
        },
        created(){
            const {config} = this;
            const THIS = this;
            const radio = 100 / (Number(config.width) || 4000);
            const qrCode = new window.QRCodeStyling({
                ...config,
                width: Number(config.width) * radio,
                height: Number(config.height) * radio,
                margin: Number(config.margin) * radio,
            });
            if(config.shape && config.shape == "circle"){
                qrCode.applyExtension(window.QRBorderPlugin({
                    ...config.borderRadius,
                    thickness: (config.borderRadius.thickness || 0) * radio,
                    dasharray: (config.borderRadius.dasharray || 0) * radio,
                }));
            }
            qrCode.getRawData("png").then((blob) => {
                const reader = new FileReader();
                reader.onloadend = async () => {
                    const base64data = reader.result; 
                    THIS.url = base64data;
                };
                reader.readAsDataURL(blob);
            });
        }
    }
</script>

<style scoped>
    .item-preview-qr-item{
        margin-right: 5px;
         padding: 2px;
         cursor: pointer;
    }
    .item-preview-qr-item__img{
        width: 60px
    }
    .item-preview-qr-item.active{
        border: 2px solid #26bf31;
        border-radius: 5px;
    }
    .item-preview-qr-item img{
        border-radius: 3px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Render/PreviewQrType.vue